// @unocss-include
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LogoutNotice } from '../common/LogoutNotice.js';
import { SubscriptionExpiredDialog } from '../common/SubscriptionExpiredDialog.js';
import { TosPrompt } from '../common/TosPrompt.js';
import { DeveloperErrorDialog } from './DeveloperErrorDialog.js';
import { PwaInstaller } from './PwaInstaller.js';
import { ResetNotifier } from './ResetNotifier.js';
export function Essentials() {
    return (_jsxs(_Fragment, { children: [_jsx(LogoutNotice, {}), _jsx(TosPrompt, {}), _jsx(SubscriptionExpiredDialog, {}), _jsx(ResetNotifier, {}), _jsx(DeveloperErrorDialog, {}), _jsx(PwaInstaller, {})] }));
}
//# sourceMappingURL=Essentials.js.map